'use client'

import React from 'react'

import { UnderlineIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'

import { Button, type ButtonProps } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip'

import { cn } from '@/utils'

import { useToolbar } from './toolbar-provider'

const UnderlineToolbar = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, onClick, ...props }, ref) => {
    const { editor } = useToolbar()
    const t = useTranslations('components.tiptap.toolbars')

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className={cn(
              'h-8 w-8 p-0 sm:h-9 sm:w-9',
              editor?.isActive('underline') && 'bg-accent',
              className
            )}
            disabled={!editor?.can().chain().focus().toggleUnderline().run()}
            onClick={(e) => {
              editor?.chain().focus().toggleUnderline().run()
              onClick?.(e)
            }}
            ref={ref}
            size="icon"
            type="button"
            variant="ghost"
            {...props}
          >
            {children ?? <UnderlineIcon className="h-4 w-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <span>{t('underline')}</span>
          <span className="text-gray-11 ml-1 text-xs">(cmd + u)</span>
        </TooltipContent>
      </Tooltip>
    )
  }
)

UnderlineToolbar.displayName = 'UnderlineToolbar'

export { UnderlineToolbar }
